import api from 'services/api';
import { array, num, object, refuseDegraded, str } from 'validation';
import { readResponse } from 'api/shared/readResponse';

// Source of truth for the wire shape: nap-backend `routes/roles.js` GET /roles, which responds
// `{ roles, pagination, config, filtersConfig }`. Only `roles` is consumed here, and each role row
// carries more than an LOV needs (ssoroleid, notification_email, …). The projection narrows to the
// identifiers an LOV row renders.

export interface RoleSummary {
  readonly role_id: number;
  readonly name: string;
}

const summarySchema = object<RoleSummary>({
  role_id: num(),
  name: str(),
});

interface RolesResponse {
  readonly roles: readonly RoleSummary[];
}

const responseSchema = object<RolesResponse>({
  roles: array(summarySchema),
});

const LOV_LIMIT = 1000;

/**
 * Fetch all roles the current user can see, for a picker. No pagination — the LOV needs the complete
 * set so Typeahead's client-side filter has every option to match against. If the universe of roles
 * ever grows past a UX-bearable dropdown size, this is the call site to migrate to server-side search.
 */
export const getRolesLOV = async (): Promise<readonly RoleSummary[]> => {
  const res = await api.get('/roles', {
    params: { limit: LOV_LIMIT },
  });
  return refuseDegraded(readResponse(res.data, { schema: responseSchema, source: 'getRolesLOV' })).roles;
};
